export function applyViewProperties(rootView) {
  if (rootView === void 0) {
    rootView = {};
  }
  return addressForms => {
    const fieldSettings = rootView.fieldSettings;
    if (fieldSettings) {
      var _addressForms$fields;
      const modifiedFields = (_addressForms$fields = addressForms.fields) == null ? void 0 : _addressForms$fields.map(field => field.target ? overrideFieldProperties(field, fieldSettings[field.target]) : field);
      return {
        ...addressForms,
        fields: modifiedFields
      };
    } else {
      return addressForms;
    }
  };
}
function overrideFieldProperties(field, settings) {
  if (settings) {
    return {
      ...field,
      hidden: settings.show === undefined ? field.hidden : !settings.show
    };
  } else {
    return field;
  }
}
//# sourceMappingURL=apply-view-properties.js.map